import React, { useState } from "react";
import "./EventReviewForm.css";

import axios from "axios";
import serverConfig from "../config";
//import toast, { Toaster } from "react-hot-toast";

const EventReviewForm = () => {
  const [formData, setFormData] = useState({
    username: "",
    title: "",
    text: "",
    mail: "",
    publicReview: true,
  });

  const [waitForResponseSend, setWaitForResponseSend] = useState(false);
  //const [responseSendInfo, setResponseSendInfo] = useState(null);
  const [responseSendInfo, setResponseSendInfo] = useState({
    status: null,
    message: "waiting",
  });

  const onSubmit = (formData) => {
    setWaitForResponseSend(true);
    axios
      .post(`${serverConfig.serverUrl}/add_feedback`, {
        formData,
      })
      .then((response) => {
        const message = response.data["message"];
        const status = response.data["exist"];
        if (status) {
          //toast.success(message);
          setResponseSendInfo({
            status: true,
            message: message
            //  "Il tuo feedback è stato inviato correttamente. Il DSM ringrazia",
          });
        } else {
          //toast.error(message);
          setResponseSendInfo({
            status: false,
            //message: "Il tuo feedback è stato non inviato correttamente.",
            message: message,
          });
        }
      })
      .catch((error) => {
        //toast.error("La risorsa non è al momento disponibile");
        setResponseSendInfo({
          status: false,
          message: "Errore di connessione",
        });
      });

    setTimeout(() => {
      setWaitForResponseSend(false);
      setResponseSendInfo({ status: null, message: "waiting" });
    }, 3000);
  };

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const sendEmail = (formData) => {
    //const mailtoLink = `mailto:maioantonio3@gmail.com?subject=${encodeURIComponent(
    const mailtoLink = `mailto:feedback@spettrometriadimassa.org?subject=${encodeURIComponent(
      formData.title
    )}&body=${encodeURIComponent(
      `Nome: ${formData.username}\nCommento: ${formData.text}${
        formData.publicReview ? "\n\nDA APPROVARE" : ""
      }`
    )}`;
    window.location.href = mailtoLink;
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    onSubmit(formData);
    //sendEmail(formData);

    setFormData({
      username: "",
      title: "",
      text: "",
      publicReview: true,
    });
  };



  const contentResponseSend = ({ status, message }) => {
    let style = {
      marginTop: "15px",
      padding: "10px",
      borderRadius: "5px",
      textAlign: "center",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: "10px",
    };

    let icon = null;

    if (status === null) {
      style = {
        ...style,
        backgroundColor: "#e2e3e5",
        color: "#383d41",
        border: "1px solid #d6d8db",
      };
      icon = <span className="spinner" />;
    } else if (status === true) {
      style = {
        ...style,
        backgroundColor: "#d4edda",
        color: "#155724",
        border: "1px solid #c3e6cb",
      };
      icon = <span className="check-icon" />;
    } else if (status === false) {
      style = {
        ...style,
        backgroundColor: "#f8d7da",
        color: "#721c24",
        border: "1px solid #f5c6cb",
      };
      icon = <span className="cross-icon" />;
    }

    return (
      <div style={style}>
        {icon}
        <span>{message}</span>
      </div>
    );
  };

  return (
    <div className="form-container">
      {/*<Toaster />*/}

      {waitForResponseSend ? (
        contentResponseSend(responseSendInfo)
      ) : (
        <>
          <h2>Lascia il tuo Feedback</h2>
          <form onSubmit={handleSubmit}>
            <div className="form-group">
              <label htmlFor="name">NOME & COGNOME</label>
              <input
                type="text"
                id="username"
                name="username"
                value={formData.username}
                onChange={handleChange}
                placeholder="Inserisci il tuo nome"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="object">TITOLO</label>
              <input
                type="text"
                id="title"
                name="title"
                value={formData.title}
                onChange={handleChange}
                placeholder="Inserisci l'oggetto"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="feedback">FEEDBACK</label>
              <textarea
                id="text"
                name="text"
                value={formData.text}
                onChange={handleChange}
                placeholder="Scrivi il tuo commento"
                required
              />
            </div>
            <div className="form-group">
              <label htmlFor="mail">E-MAIL</label>
               <input
                type="text"
                id="mail"
                name="mail"
                value={formData.mail}
                onChange={handleChange}
                placeholder="Inserisci l'email se desideri essere ricontattato"
              />
            </div>
            <div className="form-group">
              <label>
                <input
                  type="checkbox"
                  name="publicReview"
                  checked={formData.publicReview}
                  onChange={handleChange}
                />
                Permesso di renderla pubblica (dopo approvazione della
                Divisione)
              </label>
            </div>
            <div className="form-group">
              <button type="submit" className="submit-button">
                Invia la Recensione
              </button>
            </div>
          </form>
        </>
      )}
    </div>
  );
};

export default EventReviewForm;
